export default "/images/vendor/flag-icons/flags/1x1/aq.svg?0aff28faa2b3abc8e49af155b7c41972";